module.exports = __webpack_public_path__ + "static/media/homeButtonOutlineWhite.ed0744e7.svg";